import { z } from 'zod'

export const previsionsSearchSchema = z.object({
  storeIds: z.array(z.number().int().positive()).optional().default([]),
  horizon: z.number().int().min(1).max(60).optional().default(12),
  view: z.enum(['calendaire', 'cohorte']).optional().default('calendaire'),
  poolIds: z.array(z.number().int().positive()).optional().default([]),
  tab: z.enum(['forecast', 'backtest']).optional().default('forecast'),
  model: z.enum(['growth', 'weekly']).optional().default('growth'),
  ratioMethod: z.enum(['median', 'geometric', 'arithmetic']).optional().default('arithmetic'),
  growthSeasonality: z.boolean().optional().default(false),
  growthComposition: z.boolean().optional().default(false),
  growthWeeklyFirstYear: z.boolean().optional().default(false),
})

export type PrevisionsSearch = z.infer<typeof previsionsSearchSchema>
